import { defineStore } from "pinia";
import type { PmsProductCategory } from "~/types";

export const useCategoriesStore = defineStore("categoriesStore", () => {

  const isLoading = ref(true);

  const shouldDisplayImage = ref(false);

  const showCartButton = ref(true)

  const categoryMap = ref<Record<number, PmsProductCategory[]>>({})

  const categories = ref<PmsProductCategory[]>([])
  function toggleCartButton(value: boolean) {
    showCartButton.value = value
  }

  function setShouldDisplayImage(display: boolean) {
    shouldDisplayImage.value = display;
    console.log('shouldDisplayImage', shouldDisplayImage.value)
  }

  const isCategoryMapEmpty = computed(() => Object.keys(categoryMap.value).length === 0);
  async function fetchCategoriesData() {
    isLoading.value = true;
 
    const userRepo = homeRepository()
    try {
      // Fetch from API if not cached or cache is stale
      const data = await userRepo.getCategoriesFull()
      if (data.code === 200) {
        const categoryList: PmsProductCategory[] = data.data
        categories.value = categoryList
        categoryMap.value = createCategoryMap(categoryList)
        isLoading.value = false;
      }
    } catch (error) {
      console.error('Failed to fetch categories', error)
      isLoading.value = false;
      // Handle error as needed
    }
  }

  const getSubcategoriesByParentId = (parentId: number): PmsProductCategory[] | undefined => {
    return categoryMap.value[parentId]
  }

  const createCategoryMap = (categories: PmsProductCategory[]): Record<number, PmsProductCategory[]> => {
    const categoryMap: Record<number, PmsProductCategory[]> = {}

    for (const category of categories) {
      const parentId = category.parentId ?? 0
      if (!categoryMap[parentId]) {
        categoryMap[parentId] = []
      }
      categoryMap[parentId].push(category)
    }

    return categoryMap
  }

  return {
    isLoading,
    shouldDisplayImage,
    showCartButton,
    categoryMap,
    categories,
    isCategoryMapEmpty,
    setShouldDisplayImage,
    toggleCartButton,
    fetchCategoriesData,
    getSubcategoriesByParentId
  };
}, {

  persist: {
    key: 'categoriesStore1',
    storage: piniaPluginPersistedstate.localStorage(),
  },

});
